<template>
  <section class="collection-page legacy-collection">
    <header class="collection-header">
      <div><span class="eyebrow">Relacionamento</span><h2>Automações</h2><p>Crie jornadas automáticas e acompanhe cada contato.</p></div>
      <router-link
        :to="{
          name: 'AutomationNew',
          params: {  },
        }"
      >
        <div class="button primary"><i class="fas fa-plus"></i> Nova automação</div>
      </router-link>
    </header>
    <div class="collection-toolbar">
      <div class="result-count"><span>{{ totalAutomations | number }}</span> automações encontradas</div>
      <div class="flex w100 end filters-groupo-holder">
        <!-- pagination -->
        <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :click-handler="clickCallback"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
      </div>
    </div>

    <div class="flex-1 w100 margin-to-l">
      <ul>
        <li v-for="(aut, index) in automations" :key="index">
          <div class="box margin-top-m">
            <div class="box-content">
              <div class="flex middle row">
                <div class="flex-3">
                  <div class="flex middle row">
                    <div class="flex-1 name margin-top-s">
                      <p>
                        {{ aut.name }}
                      </p>
                      <div class="flex column">
                        <div><small>{{ aut.auto_type }}</small></div>
                      </div>
                    </div>
                    <div class="flex-2 margin-top-s">
                      <div class="flex details between">
                        <div class="status">
                          <p>Status</p>
                          <small>{{ decodeStatus(aut.status) }}</small>
                        </div>
                        <div>
                          <p>Contatos na Automação</p>
                          <small v-if="aut.totalContacts !== undefined">
                            {{ _calContactRestantes(aut.totalContacts, aut.reportContact) | number }}
                          </small>
                          <span v-else class="metric-loader" role="status" aria-label="Carregando contatos"></span>
                        </div>
                        <div>
                          <p>Envios</p>
                          <div v-if="['ACTIVE'].includes(aut.status)">
                            <small v-if="aut.reportContact !== undefined" >
                              {{ aut.reportContact | number }}
                            </small>
                            <span v-else class="metric-loader" role="status" aria-label="Carregando envios"></span>
                          </div>
                          <div v-else>
                            -
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="action">
                  <div class="flex end">
                    <div v-if="aut.status === 'STOP'" class="button primary" @click="updateStatus(aut, 'ACTIVE')">
                      <i class="fas fa-play"></i>
                    </div>
                    <div v-else-if="aut.status === 'ACTIVE'" class="button primary" @click="updateStatus(aut, 'STOP')">
                      <i class="fas fa-stop"></i>
                    </div>
                    
                    <router-link
                      :to="{
                        name: 'AutomationDetail',
                        params: { automation_id: aut.id },
                      }"
                      style="margin-left:8px"
                    >
                      <div class="button secondary"><i class="fas fa-chart-pie"></i></div>
                    </router-link>

                    <router-link
                      :to="{
                        name: 'AutomationEdit',
                        params: { automation_id: aut.id },
                      }"
                      style="margin-left:8px"
                    >
                      <div class="button secondary"><i class="fas fa-edit"></i></div>
                    </router-link>
                    <a class="button secondary" @click="openModalDuplicate(aut.id)"  style="margin-left:8px"><i class="fas fa-copy"></i></a>
                    <a @click="openModalDelete(aut.id)" style="margin-left: 8px">
                      <div class="button secondary"><i class="fas fa-trash"></i></div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="isEmpty" class="empty-state">
        <div class="empty-icon"><i class="fas fa-robot"></i></div>
        <h3>Automatize sua primeira jornada</h3>
        <p>Crie uma automação para manter seus contatos sempre engajados.</p>
        <router-link :to="{ name: 'AutomationNew' }" class="button primary"><i class="fas fa-plus"></i> Criar automação</router-link>
      </div>

      <div v-if="loading">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <!-- pagination -->
      <div class="flex-1 flex row w100 middle">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
              <paginate
                :containerClass="'pagination'"
                :page-count="totalPages"
                v-model="page"
                :page-range="5"
                :click-handler="clickCallback"
                :prev-text="'Anterior'"
                :next-text="'Próxima'"
              ></paginate>
            </div>
        </div>
      </div>

    </div>
    <!-- modal confirm delete -->
    <modal-confirm
      :show="showDeleteModal"
      description="Você tem certeza que deseja deletar essa automação?"
      @cancel="
        showDeleteModal = false;
        selectModalDelete = null;
      "
      @accept="removeAutomation(selectModalDelete)"
    ></modal-confirm>

    <!-- modal confirm duplicate -->
    <modal-confirm
      :show="showDuplicateModal"
      description="Você tem certeza que deseja duplicar essa automação?"
      @cancel="
        showDuplicateModal = false;
        selectedModalDuplicate = null;
      "
      @accept="duplicateAuto(selectedModalDuplicate)"
    ></modal-confirm>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import { 
  getAutomations,
  updateAutomation,
  removeAutomation,
  duplicateAutomation,
  getAutomationContactReport
} from "@/services/automation";

import { 
  getContacts,
} from "@/services/contact";



import ModalConfirm from "@/components/modal/ModalConfirm";


export default {
  name: "automations",
  components: { 
    ModalConfirm
  },
  data() {
    return {
      loading: false,
      showDeleteModal: false,
      selectModalDelete: null,
      showDuplicateModal: false,
      selectedModalDuplicate: null,
      filters: {
        data: {},
        list: {},
      },
      automations: [],
      totalAutomations: 1,
      offset: 20,
      page: 1,
    };
  },
  mounted() {
    this.getAutomations();
  },
  computed: {
    isEmpty() {
      // return !this.loading && this.products && this.products.length === 0;
      return this.totalAutomations === 0 && !this.loading;
    },
    totalPages() {
      let valueMode = this.totalAutomations % this.offset;
      let value = this.totalAutomations / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
  },
  watch: {
    "page": {
      handler() {
        this.contacts = [];
        this.getAutomations();
      }
    }
  },
  methods: {
    duplicateAuto(autoId) {
      this.showDuplicateModal = false
      this.selectedModalDuplicate = null
      
      duplicateAutomation(autoId)
      .then((result)=> {
        this.automations.unshift(result)

        this.$toast.success({
          title:'Sucesso',
          message:'Automação duplicada com sucesso'
        })


      })
      .catch(() => {
        this.$toast.error({
          title:'Erro',
          message:'Ocorreu algum problema'
        })
      })
    },
    _calContactRestantes(total, sends) {
      if (total === undefined || sends === undefined) return '-'

      return total - sends
    },
    decodeStatus(status) {
      let _map = {
        'ACTIVE': 'ATIVA',
        'STOP': 'PAUSADA',
        'DRAFT': 'RASCUNHO',
      }

      return _map[status] || status
    },
    updateStatus(aut, newStatus) {
      this.updateAutomation(aut, newStatus)
    },
    alertScheduling(aut) {
      this.$toast.success({
        title:'Sucesso',
        message:`Sua autanha tem o disparo agendado! Para: ${aut.scheduling}`
      })
    },
    openModalDelete(autId) {
      this.showDeleteModal = true
      this.selectModalDelete = autId
    },
    openModalDuplicate(autId) {
      this.showDuplicateModal = true
      this.selectedModalDuplicate = autId
    },
    removeAutomation(autId) {
      this.showDeleteModal = false
      this.selectModalDelete = null

      removeAutomation(autId)
        .then(() => {
          this.automations = this.automations.filter(c => c.id != autId)

          this.$toast.success({
            title:'Sucesso',
            message:'autanha removido com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao remover autanha'
          })
        })
    },
    getAutomations() {
      this.loading = true;
      let params = {
        page: this.page,
        offset: this.offset,
      };
      getAutomations(params)
        .then((result) => {
          this.automations = result.automations.map((p) => {
            return Object.assign({ 
              totalContacts: undefined,
              totalSends: undefined,
            }, p)
          });
          this.totalAutomations = result.total
          // get contacts
          this.automations.forEach(aut => {
            this.getContacts(aut)
            this.getAutomationContactReport(aut)
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar automações",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateAutomation(aut, newStatus) {
      let params =  {
          status: newStatus
      }
      updateAutomation(aut.id, params)
        .then(() => {
          if (newStatus === 'PROGRESS') {
            this.$toast.success({
              title:'Sucesso',
              message:'Disparo iniciado da autanha.'
            })
          } else {
            this.$toast.success({
              title:'Sucesso',
              message:'autanha Pausada'
            })
          }

          aut.status = newStatus
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    getContacts(aut) {
      let params = {
        page: 1,
        offset: 1,
        tag: aut.contact_tag_id,
        list: aut.contact_list_id,
        automation:  aut.id,
      };
      getContacts(params)
        .then((result) => {
          aut.totalContacts = result.total
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar total de contatos",
          });
        })
    },
    getAutomationContactReport(aut) {
      getAutomationContactReport(aut.id)
      .then((result) => {
        aut.reportContact = result.total
      })
      .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

        this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar total de contatos enviados",
          });
      })
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../collection-page";

.legacy-collection > div:nth-of-type(2) > ul { list-style: none; }
.legacy-collection > div:nth-of-type(2) > ul > li > .box { margin-top: 12px; border-radius: 14px; }
.legacy-collection .box-content > .flex { gap: 20px; }
.legacy-collection .name p { color: #171923; font-size: 1.5rem; font-weight: 700; }
.legacy-collection .name small { color: #7c3aed; font-size: 1.05rem; font-weight: 650; text-transform: uppercase; }
.legacy-collection .details > div { min-width: 90px; margin-right: 28px; }
.legacy-collection .details p { margin-bottom: 5px; color: #98a2b3; font-size: 1.05rem; font-weight: 600; text-transform: uppercase; }
.legacy-collection .details small { color: #344054; font-size: 1.3rem; font-weight: 700; }
.legacy-collection .action { margin-left: 8px; }
.legacy-collection .action .button { min-width: 40px; min-height: 40px; padding: 11px; }

@media screen and (max-width: 1024px) {
  .legacy-collection .box-content > .flex, .legacy-collection .box-content .flex.row { align-items: stretch; }
  .legacy-collection .details { margin-top: 14px; flex-direction: row !important; }
  .legacy-collection .action { margin: 16px 0 0; }
}
@media screen and (max-width: 640px) {
  .legacy-collection .details { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  .legacy-collection .details > div { margin: 0; }
  .legacy-collection .action .flex { flex-direction: row !important; flex-wrap: wrap; justify-content: flex-start; }
}
</style>
